/**
 * Helper functions to generate GraphQL API url for Contentful.
 * @param spaceId Contentful space id to use in url
 * @param environment Contentful environment name to use in url
 * @returns string containing a GraphQL url to Contentful API based on spaceId and environment.
 */
export function contentfulAPIURL(spaceId: string, environment: string): string {
  return `https://graphql.contentful.com/content/v1/spaces/${spaceId}/environments/${environment}`;
}
